import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_RESOURCES_KEY } from '_api/queries';
import { Resource, ResourcePayload } from '_api/types';

export const CREATE_RESOURCE = 'create-resource';

export const useCreateResource = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Resource, ResourcePayload>(
    () => '/resource/create',
    'post',
    {},
    {
      mutationKey: [CREATE_RESOURCE],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_RESOURCES_KEY] });
      },
    },
    (body: ResourcePayload) => JSON.stringify(body),
  );
};
